<div class="page-container">
  <div class="left-section">
    <div class="decorative-element element-1">
      <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M40.7,-69.2C50.9,-60.6,55.9,-44.8,62.4,-29.8C68.9,-14.8,76.9,-0.6,76.4,13.4C75.9,27.4,66.9,41.2,56.1,53.2C45.3,65.2,32.7,75.4,17.8,78.5C2.9,81.6,-14.4,77.6,-28.8,70.3C-43.2,63,-54.8,52.4,-63.2,39.7C-71.6,27,-76.8,12.2,-75.1,-1.7C-73.4,-15.6,-64.8,-28.6,-54.6,-37.8C-44.4,-47,-32.6,-52.4,-20.9,-59.9C-9.2,-67.4,2.4,-77,16.5,-79.1C30.6,-81.2,47.2,-75.8,40.7,-69.2Z" 
              transform="translate(100 100)" fill="rgba(255,255,255,0.12)"/>
      </svg>
    </div>

    <div class="hero-content">
      <h1>Manage the essence<br>of your life digitally</h1>
      <div class="illustration-container">
        <img src="assets/images/introillustration.png" alt="Digital Life Management" class="illustration">
      </div>
    </div>
    <div class="copyright">Lex-Z 2026. All rights reserved.</div>
  </div>

  <div class="right-section">
    <div class="form-container">
      <div class="header-content">
        <div class="login-header">
          <img class="logo" src="assets/images/lex-z_logo.png" alt="Lex-Z" class="logo"/> 
          <!-- <h2>{{ otpSent ? 'Login with OTP' : 'Sign in to Lex-Z' }}</h2> -->
        </div>
      </div>
      <h2 class="register-title">{{ otpSent ? 'Verify OTP' : 'Log in to your account' }}</h2>

      <form [formGroup]="loginForm">
        <!-- OTP Sent Message -->
        <div *ngIf="otpSent" class="otp-sent-message">
          <p>OTP sent to your {{ loginType === 'email' ? 'email' : 'mobile number' }}</p>
        </div>

        <div class="form-fields">
          <!-- Email or Mobile Field (hidden when OTP is sent) -->
          <div class="form-field" *ngIf="!otpSent">
            <input
              type="text" 
              (input)="restricttextSpace($event)"
              (keydown.enter)="onLoginButtonClicked()"
              formControlName="emailOrMobile" 
              placeholder="Email or Mobile Number"
              autocomplete="username">
            <div *ngIf="submitted && f['emailOrMobile'].errors">
              <div class="errorStyle" *ngIf="f['emailOrMobile'].errors?.['required']">
                Email or Mobile number is required
              </div>
              <div class="errorStyle" *ngIf="f['emailOrMobile'].errors?.['invalidEmailOrMobile']">
                Please enter a valid email or mobile number
              </div>
            </div>
          </div>

          <!-- Password Field (hidden when using OTP) -->
          <div class="form-field password-field" *ngIf="!useOTP && !otpSent">
            <input
              [type]="hidePassword ? 'text' : 'password'" 
              formControlName="password" 
              (input)="restricttextSpace($event)"
              (keydown.enter)="onLoginButtonClicked()"
              placeholder="Enter your password"
              autocomplete="current-password">
            <button type="button" class="toggle-password" (click)="hidePassword = !hidePassword">
              <i class="fas" [class.fa-eye]="hidePassword" [class.fa-eye-slash]="!hidePassword"></i>
            </button>
            <div *ngIf="submitted && f['password'].errors">
              <div class="errorStyle" *ngIf="f['password'].errors">Password is required</div>
            </div>
          </div>

          <!-- OTP Input Fields (6 separate boxes) -->
          <div class="otp-input-container" *ngIf="useOTP && otpSent">
            <label class="otp-label">Enter OTP</label>
            <div class="otp-boxes">
              <input
                #otp1
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[0]"
                [ngModelOptions]="{standalone: true}"
                (keyup)="onOtpKeyUp($event, 1, otp2)"
                (keydown)="onOtpKeyDown($event, 1)"
                (paste)="onOtpPaste($event)"
                autocomplete="off">
              <input
                #otp2
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[1]"
                [ngModelOptions]="{standalone: true}"
                (keyup)="onOtpKeyUp($event, 2, otp3)"
                (keydown)="onOtpKeyDown($event, 2)"
                autocomplete="off">
              <input
                #otp3
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[2]"
                [ngModelOptions]="{standalone: true}"
                (keyup)="onOtpKeyUp($event, 3, otp4)"
                (keydown)="onOtpKeyDown($event, 3)"
                autocomplete="off">
              <input
                #otp4
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[3]"
                [ngModelOptions]="{standalone: true}"
                (keyup)="onOtpKeyUp($event, 4, otp5)"
                (keydown)="onOtpKeyDown($event, 4)"
                autocomplete="off">
              <input
                #otp5
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[4]"
                [ngModelOptions]="{standalone: true}"
                (keyup)="onOtpKeyUp($event, 5, otp6)"
                (keydown)="onOtpKeyDown($event, 5)"
                autocomplete="off">
              <input
                #otp6
                type="text"
                class="otp-box"
                maxlength="1"
                inputmode="numeric"
                [(ngModel)]="otpDigits[5]"
                [ngModelOptions]="{standalone: true}"
                (keyup)="onOtpKeyUp($event, 6, null)"
                (keydown)="onOtpKeyDown($event, 6)"
                (keydown.enter)="onLoginButtonClicked()"
                autocomplete="off">
            </div>
            <div *ngIf="submitted && f['otp'].errors" class="text-danger">
              <div class="errorStyle" *ngIf="f['otp'].errors?.['required']">OTP is required</div>
              <div class="errorStyle" *ngIf="f['otp'].errors?.['pattern']">OTP must be 6 digits</div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <label class="remember-me" *ngIf="!useOTP && !otpSent">
            <input type="checkbox" formControlName="rememberMe">
            <span>Remember me</span>
          </label>
          
          <!-- Toggle between Password and OTP -->
          <a href="javascript:void(0)" 
             class="toggle-login-method" 
             (click)="toggleLoginMethod()"
             [ngClass]="{'togglepass': useOTP}">
            {{ useOTP ? 'Use Password Instead' : 'Use OTP Instead' }}
          </a>

          <!-- Resend OTP link with timer -->
          <div *ngIf="otpSent" class="resend-container">
            <span *ngIf="!canResend" class="resend-timer">
              Resend OTP in {{ resendTimer }}s
            </span>
            <a *ngIf="canResend" 
               href="javascript:void(0)" 
               class="resend-otp" 
               (click)="resendOTP()">
              Resend OTP
            </a>
          </div>

          <!-- <a routerLink="/forgot-password" class="forgot-password" *ngIf="!useOTP && !otpSent">
            Forgot Password ?
          </a> -->
        </div>

        <!-- Button Container -->
        <div class="button-container">
          <button type="button" 
                  class="login-button" 
                  (click)="onLoginButtonClicked()">
            <span>{{ otpSent ? 'Verify OTP' : (useOTP ? 'Send OTP' : 'Log In') }}</span>
          </button>

          <!-- Cancel OTP button -->
          <button *ngIf="otpSent" 
                  type="button" 
                  class="cancel-button" 
                  (click)="cancelOTP()">
            <span>Cancel</span>
          </button>
        </div>
                  
         <!-- <a *ngIf="!otpSent" href="javascript:void(0)" 
             class="toggle-login-method" 
             (click)="toggleLoginMethod()">
            {{ useOTP ? '' : 'Login with OTP' }}
          </a> -->
          <div *ngIf="!useOTP" class="lx-forgot">
            <a class="lx-forgot-link" routerLink="/forgot-password">Forgot Password?</a>
          </div>

        <div class="register-prompt">
          Don't have an account ? <a routerLink="/register" class="register-link">Register Here</a>
        </div>
      </form>
    </div>
  </div>
</div>